import { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../axios/axios";
import { message } from "antd";
import DataTable from "react-data-table-component";
import { adminConfig } from "../../utils/adminConfig";

export default function TVIMembersActivePlan() {
  const [loading, setLoading] = useState(false);
  const [allPlan, setAllPlan] = useState([]);

  useEffect(() => {
    getAllPlans();
  }, []);

  const getAllPlans = () => {
    setLoading(true);

    axios
      .get("/stripe-plan-get-source-wise/tvi", adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const filterData = res.data.data.filter(plan => plan.plan_status == true);
          setAllPlan(filterData);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        message.error("Something went wrong");
      });
  };

  const columns = [
    {
      name: "Name",
      selector: ({ name }) => name,
      width: "350px",
    },
    {
      name: "Status",
      selector: ({ plan_status }) => (plan_status ? "Active" : "Inactive"),
      width: "150px",
    },

    {
      name: "Action",
      selector: (row) => (
        <a
          className="btn btn-primary"
          href={`/plan-wise-all-members/tvi/${row.id}?planName=${row.name}`}
          target="_blank"
          rel="noreferrer"
        >
          View Members
        </a>
      ),
      width: "300px",
    },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>TVI Members Active on Each Plan</h3>
                </div>

                <DataTable
                  columns={columns}
                  data={allPlan.filter(plan => plan.name !== 'TVI Star' && plan.name !== 'TVI Star Experience')}
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}



const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },
  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);
